import { Box, CardContent, Typography } from "@mui/material";
import commonStyles from "../../../styles/common.module.css";
import ErrorIcon from "@mui/icons-material/Error";
import { FAILURES } from "../../../types/onboard";
import ErrorTable from "./ErrorTable";
import { useTranslation } from "react-i18next";
interface Props {
  header: string;
  description: string;
  body: string;
  images?: string[];
  tip?: string;
  buttonLabel: string;
  onClick: () => void;
  onContinue:()=> void;
  continueButtonRequired?:boolean;
}

const Failure = ({
  header,
  description,
  body,
  images,
  tip,
  buttonLabel,
  onClick,
  onContinue,
  continueButtonRequired = true
}: Props) => {
  const {t} = useTranslation()
  return (
    <div className={commonStyles.failureContainer}>
      <div className={commonStyles.errorBadge}>   
        <ErrorIcon sx={{
            color:"var(--color-warning)"
          }} />
        <div className={commonStyles.errorHeader}>
          {header}
          </div>
      </div>
      <CardContent>
        {header == t(FAILURES.PRIMARY_DOCUMENT_CAPTURE) ? (
          <ErrorTable description={description} />
        ) : (
          <span className={commonStyles.errorDescription}>{description}</span>
        )}

        <p className={commonStyles.failureDescription}>{body}</p>
        <Box>
          {images?.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Instruction step ${index + 1}`}
              style={{ width: "100%", borderRadius: 8, marginBottom: 8 }}
            />
          ))}
        </Box>
        {tip && (
          <Typography variant="body1" color="textSecondary">
            {tip}
          </Typography>
        )}
        <div className={commonStyles.bottomFloatButtonContainer}>
        <button onClick={onClick} className={commonStyles.button_primary}>{buttonLabel}</button>
        {continueButtonRequired && (
          <button
            onClick={onContinue}
            className={commonStyles.button_secondary}
          >
            {t('button.continue')}
          </button>
        )}

        </div>
        
      </CardContent>
    </div>
  );
};

export default Failure;
